import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HtmlFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "HtmlFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.31 24.39h2.8v1.87c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.55c-.03-.12-.07-.24-.12-.34s0-.07 0-.07c-.06-.11-.14-.21-.22-.3l-7.56-7.5c-.08-.08-.18-.16-.29-.22s-.08 0-.08 0c-.1-.05-.21-.09-.33-.11s-9.62 0-9.62 0c-2.31 0-4.18 1.86-4.21 4.16v7.95h-2.8c-1.03 0-1.87.84-1.87 1.87v6.54c0 1.03.84 1.87 1.87 1.87Zm12.95-8.28 2.8 2.79c.08.08.14.2.14.33s-.05.25-.14.33l-2.8 2.82a.48.48 0 0 1-.69-.67l2.47-2.47-2.47-2.47a.48.48 0 0 1-.14-.33c0-.26.21-.47.47-.47.13 0 .25.05.33.14h.02Zm-6.16 6.36a.48.48 0 0 1-.27-.42c0-.08.02-.16.06-.23s2.76-5.59 2.76-5.59c.08-.15.24-.26.42-.26a.47.47 0 0 1 .42.68s-2.79 5.61-2.79 5.61a.476.476 0 0 1-.63.2s.02.01.02.01Zm-2.26-6.36c.08.08.14.2.14.33s-.05.25-.14.33l-2.47 2.47 2.47 2.47c.08.08.14.2.14.33 0 .26-.21.47-.47.47-.13 0-.25-.05-.33-.14l-2.8-2.8c-.08-.08-.14-.2-.14-.33s.05-.25.14-.33l2.8-2.8c.08-.08.2-.14.33-.14s.25.05.33.14m1.07-9.95c0-.77.63-1.4 1.4-1.4h7.95V9.9c0 1.29 1.05 2.34 2.34 2.34h5.14v14.02c0 .77-.76.97-1.4.97H11.32c-.64 0-1.4-.17-1.4-.97v-1.87h11.22c1.03 0 1.87-.84 1.87-1.87v-6.54c0-1.03-.84-1.87-1.87-1.87H9.92V6.16Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.25 27.2c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.59-2.59-2.59-2.59a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.4 3.4a1.16 1.16 0 0 1 0 1.62l-3.4 3.4c-.22.22-.52.33-.81.33M11.65 27.2c-.29 0-.58-.11-.81-.33l-3.4-3.4a1.14 1.14 0 0 1 0-1.62l3.4-3.4c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-2.59 2.59 2.59 2.59a1.14 1.14 0 0 1-.81 1.95M16.92 29.54a1.145 1.145 0 0 1-1.11-1.44l3.06-11.43c.16-.61.79-.97 1.4-.81s.97.79.81 1.4l-3.06 11.43c-.14.51-.6.85-1.1.85"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.43 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43H19c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H5.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h1.14a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 16.71c-.63 0-1.14-.51-1.14-1.14v-2.29h-5.71c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86c.63 0 1.14.51 1.14 1.14v3.43c0 .63-.51 1.14-1.14 1.14"
      })]
    })
  }));
};
HtmlFileIcon.displayName = 'HtmlFileIcon';